import { render, staticRenderFns } from "./ContactComponent.vue?vue&type=template&id=49d65ffe"
import script from "./ContactComponent.vue?vue&type=script&lang=ts"
export * from "./ContactComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports